var exports = {
  "z": "x93eb46d8--aec0dc--root",
};

module.exports = exports;
